import { Injectable } from '@angular/core';

import { DataFieldDropdown } from './DataFieldDropdown';
import { DataFieldTextBox } from './DataFieldTextBox';
import { PathTestService } from '../../../../core/services/path-test.service';

@Injectable()
export class DataFieldService {

  participantFields : DataFieldTextBox[] = []

  constructor( public pathTestService: PathTestService) {

  }

  // TODO: get from a remote source of taskData metadata
  getFields() {
    this.participantFields = this.buildParticipantFields()
    let fields: any = [
      {
        title: "Call Counts",
        forms: [

          new DataFieldTextBox({
            key: 'callsPlaced',
            label: 'Calls placed (#)',
            type: 'number',
            required: true,
            order: 1
          }),

          new DataFieldTextBox({
            key: 'callsCompleted',
            label: 'Calls completed (#)',
            type: 'number',
            required: true,
            order: 2
          })

        ]
      },
      {
        title: "Conditions",
        forms: [
          new DataFieldDropdown({
            key: 'hvac',
            label: 'HVAC',
            required: true,
            options: [
              { key: '', value: null},
              { key: 'on', value: 'ON' },
              { key: 'off', value: 'OFF' }
            ],
            order: 4
          }),

          new DataFieldTextBox({
            key: 'doorOpenShutCount',
            label: 'Door open/shut count (#)',
            type: 'number',
            required: true,
            order: 5
          }),

          new DataFieldDropdown({
            key: 'footTraffic',
            label: 'Foot Traffic',
            required: true,
            options: [
              { key: '', value: null},
              { key: 'none', value: 'none' },
              { key: 'light', value: 'light' },
              { key: 'medium', value: 'medium' },
              { key: 'heavy', value: 'heavy' }
            ],
            order: 6
          })
        ]
      },
      {
        title: "Participant Coverage",
        forms: this.participantFields
      },
      {
        title: "Issues",
        forms: [
          new DataFieldDropdown({
            key: 'issues',
            label: 'Issues with test location?',
            required: true,
            options: [
              { key: '', value: null},
              { key: 'no', value: 'NO' },
              { key: 'yes', value: 'YES' }
            ],
            order: 7 + this.participantFields.length
          })
        ]
      }
    ];

    return fields
    // return of(fields.sort((a, b) => a.order - b.order));
  }

  buildParticipantFields = () => this.pathTestService.participants.map( (participant,index) => new DataFieldTextBox({
      key: participant.name,
      label: `${participant.title} (dBm)`,
      type: 'number',
      required: true,
      order: 7 + index
    }
  ))
}